import React from "react";

import clsx from "clsx";

import { CustomMetricsNewBadge } from "@features/custom-metrics/custom-metrics-modal";
import {
  type MetricCategorizer,
  MetricCategory,
} from "@features/sales-v3/utils/metric-categorizer";
import { useFeatureFlags } from "@hooks/http";

import { PanelContainer } from "./panel-container";

type Props = {
  metricCategories: MetricCategorizer;
  selectedCategory: MetricCategory;
  setSelectedCategory: (category: MetricCategory) => void;
};

export const CategoriesPanel = ({
  metricCategories,
  selectedCategory,
  setSelectedCategory,
}: Props) => {
  const { hasFeatureFlag } = useFeatureFlags();
  return (
    <PanelContainer title="CATEGORY">
      <div className="h-[calc(100%-16px)] overflow-auto">
        {Object.entries(MetricCategory).map(([categoryKey, categoryName]) => {
          if (
            categoryName !== MetricCategory.ALL &&
            categoryName !== MetricCategory.USER_DEFINED &&
            categoryName !== MetricCategory.CUSTOM_GOALS &&
            metricCategories.getMetricsByCategory(categoryName).length === 0
          ) {
            return null;
          }

          if (
            !hasFeatureFlag("customMetricsV1") &&
            categoryName === MetricCategory.USER_DEFINED
          ) {
            return null;
          }

          return (
            <div
              key={categoryKey}
              className={clsx(
                categoryName === selectedCategory &&
                  clsx(
                    "bg-cosmic-4 text-interstellar+2",
                    "shadow-[inset_2px_0px_0px_0px_#7081FF] pointer-events-none",
                  ),
                "px-4 py-2 text-sm",
                "hover:bg-cosmic-4 hover:text-interstellar+2",
                "hover:shadow-[inset_2px_0px_0px_0px_#7081FF]",
                "hover:cursor-pointer truncate flex flex-row items-center",
              )}
              onClick={() => setSelectedCategory(categoryName)}
            >
              <div
                className={clsx(
                  "hover:font-bold",
                  categoryName === selectedCategory && "font-bold",
                )}
              >
                {categoryName}
              </div>
              {categoryName === MetricCategory.USER_DEFINED && (
                <CustomMetricsNewBadge className="ml-2" />
              )}
            </div>
          );
        })}
      </div>
    </PanelContainer>
  );
};
